<template>
  <div class="navbar-container">
    <div class="navbar-header">
      <div class="logo" @click="openHome">
        <img src="../../assets/img/b2b-navbar-logo.png" />
      </div>
      <div class="searchBox">
        <div class="searchInfo">
          <input class="searchInoput" :placeholder="$t('navBar.search')" v-model="searchText"
            @keyup.enter="gotoSearch" />
          <div class="searchLogo" @click="gotoSearch">
            <img class="searchLogoIcon" src="~assets/img/store/icon_home_search@2x.png" />
          </div>
        </div>
      </div>
      <div class="navBar">
        <div class="switch-box1">
          <div class="switch" type="text" @click="openHome">
            {{ $t("B2B.header9") }}
          </div>
        </div>
        <div class="switch-box2">
          <div class="switch" type="text" @click="openB2C">
            {{ $t("B2B.header11") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "navBar",
  props: {
    type: {
      type: String,
      default: "_self" //_self
    }
  },
  data() {
    return {
      searchText: ""
    };
  },
  methods: {
    gotoSearch() {
      let routeUrl = this.$router.resolve({
        path: "/catalog",
        query: { SearchText: this.searchText }
      });
      window.open(routeUrl.href, "_blank");
    },
    openHome() {
      var url = "";
      if (process.env.NODE_ENV === "development") {
        url = " http://localhost:3001"
      } else {
        url = "https://www.vancheen.com";
      }
      window.open(url, this.type);
    },
    openB2C() {
      let routeUrl = this.$router.resolve({
        path: "/home",
        query: {},
      });
      window.open(routeUrl.href, "_blank");
    },
  }
};
</script>

<style lang="scss" scoped>
.navbar-container {
  position: relative;
  height: 85px;
  width: 100%;
  z-index: 99;

  .navbar-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: #ffffff;
    border-bottom: 1px solid #01aaa3;

    .logo {
      width: 10%;
      display: inline-block;
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
      img {
        width: 80px;
        height: 80px;
      }
    }

    .searchBox {
      width: 70%;
      display: inline-block;
      text-align: center;
      vertical-align: middle;

      .searchInfo {
        width: 30%;
        padding: 8px 20px;
        border: 3px solid #01aaa3;
        display: inline-block;
        border-radius: 100px;

        .searchInoput {
          outline: none;
          padding: 0;
          width: 90%;
          border: none;
          background-color: #ffffff;
          font-size: 14px;
          color: #a7a7a7;
          vertical-align: middle;
        }

        .searchLogo {
          margin: 0;
          padding: 0;
          width: 10%;
          display: inline-block;
          text-align: right;
          vertical-align: middle;
          cursor: pointer;

          .searchLogoIcon {
            width: 20px;
            height: 20px;
            object-fit: cover;
            -webkit-object-fit: cover;
            // background-color: #434343;
          }
        }
      }
    }

    .navBar {
      width: 20%;
      display: inline-block;
      text-align: right;
      vertical-align: middle;
      cursor: pointer;

      .switch-box1 {
        display: inline-block;
        margin-right: 20px;
        padding-right: 20px;
        border-right: 1px solid #666;
        vertical-align: middle;

        .switch {
          font-size: 14px;
          font-weight: 300;
          color: #333;
          cursor: pointer;
        }
      }

      .switch-box2 {
        display: inline-block;
        margin-right: 20px;
        padding-right: 20px;
        vertical-align: middle;

        .switch {
          font-size: 14px;
          font-weight: 300;
          color: #333;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
